import { render } from "./AposI18nLocalize.vue?vue&type=template&id=4705f3a2&scoped=true"
import script from "./AposI18nLocalize.vue?vue&type=script&lang=js"
export * from "./AposI18nLocalize.vue?vue&type=script&lang=js"

import "./AposI18nLocalize.vue?vue&type=style&index=0&id=4705f3a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4705f3a2"],['__file',"i18n/ui/apos/components/AposI18nLocalize.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4705f3a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4705f3a2', __exports__)) {
    api.reload('4705f3a2', __exports__)
  }
  
  module.hot.accept("./AposI18nLocalize.vue?vue&type=template&id=4705f3a2&scoped=true", () => {
    api.rerender('4705f3a2', render)
  })

}


export default __exports__